module.exports = __webpack_public_path__ + "static/media/substitution.cfed4f4a.svg";